export const Types = {
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",
  CLEAR_API_SUCCESS: "CLEAR_API_SUCCESS",
  CLEAR_API_ERROR: "CLEAR_API_ERROR",
  FCM_DEVICE_ADDED: "FCM_DEVICE_ADDED"
};
